import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Camera } from "lucide-react";
import CompactCameraDashboard from "./CompactCameraDashboard";

const AssetDashboardLayout: React.FC = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const navigate = useNavigate();

    const info = JSON.parse(localStorage.getItem("internal_ids") || "{}");
    const asset_id = info.asset_id;
    const asset_type = info.asset_type;
    const path = info.path || "/asset";

    useEffect(() => {
        if (!asset_id) {
            navigate("/asset");
            return;
        }
        setIsLoading(false);
    }, [asset_id, navigate]);

    if (isLoading) {
        return (
            <div className="flex h-screen bg-slate-50 items-center justify-center">
                <div className="text-slate-400 animate-pulse text-lg font-black uppercase tracking-widest">
                    Loading...
                </div>
            </div>
        );
    }

    if (asset_type === "camera") {
        return <CompactCameraDashboard />;
    }

    // Default fallback for non-camera assets or unknown types
    return (
        <div className="h-screen flex flex-col bg-slate-50 overflow-hidden">
            <div className="p-3 border-b border-slate-200 flex items-center justify-between bg-white shadow-sm sticky top-0 z-50">
                <div className="flex items-center gap-3">
                    <button
                        onClick={() => navigate(path)}
                        className="p-1.5 hover:bg-slate-100 rounded-lg text-slate-400 hover:text-slate-600 transition-all active:scale-95"
                    >
                        <ArrowLeft className="w-5 h-5" />
                    </button>
                    <div className="flex flex-col">
                        <h2 className="text-sm font-black text-slate-900 uppercase tracking-tight flex items-center gap-2">
                            <Camera className="w-4 h-4 text-orange-600" />
                            {asset_type || "Asset Details"}
                        </h2>
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{info.name || info.ip_address}</p>
                    </div>
                </div>
            </div>

            <div className="flex-1 flex items-center justify-center text-slate-400 font-bold uppercase text-xs">
                Detailed view for {asset_type || "this asset type"} is currently being integrated.
            </div>
        </div>
    );
};

export default AssetDashboardLayout;
